export const SITE_URL = "https://malakbnbresort.ca";

// Sourced from CLAUDE.md property facts. Postal code and the Google Maps
// Place ID came from a third-party directory (crystalridgego.com) and should
// be reconfirmed once Google Business Profile is claimed. Geo coordinates
// were extracted from the existing map embed on /contact (see below), not
// guessed.
export const BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "Malak BnB Resort",
  description:
    "Boutique family-owned bed and breakfast in Crystal Beach, Ontario, five minutes from Bay Beach and Lake Erie, with an outdoor heated pool and continental breakfast.",
  url: `${SITE_URL}/`,
  telephone: "+1-289-929-8055",
  email: "infomalakbnb@gmail.com",
  priceRange: "C$345-C$380",
  image: [
    `${SITE_URL}/images/hero-exterior.webp`,
    `${SITE_URL}/images/gallery-pool-outdoor.webp`,
    `${SITE_URL}/images/gallery-bedroom-warm.webp`,
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "264 Ridge Road South",
    addressLocality: "Crystal Beach",
    addressRegion: "ON",
    postalCode: "L0S 1B0",
    addressCountry: "CA",
  },
  // Extracted from the pre-existing Google Maps embed on /contact (src has
  // !2d-79.0619!3d42.8661), not guessed. Re-verify if that embed is ever changed.
  geo: {
    "@type": "GeoCoordinates",
    latitude: 42.8661,
    longitude: -79.0619,
  },
  hasMap: "https://www.google.com/maps/place/?q=place_id:ChIJu6jjv8U904kRtKWZ5TBoPCw",
  amenityFeature: [
    "Outdoor heated pool",
    "Continental breakfast buffet",
    "Free Wi-Fi",
    "Air conditioning",
    "Flat screen TV",
    "In-room safe",
    "Fitness area",
    "Indoor and outdoor lounge areas",
    "Free parking",
  ].map((name) => ({ "@type": "LocationFeatureSpecification", name, value: true })),
  areaServed: [
    "Crystal Beach",
    "Fort Erie",
    "Ridgeway",
    "Niagara Region",
    "Niagara Falls",
    "Port Colborne",
    "Wainfleet",
    "Stevensville",
  ],
} as const;

interface FaqItem {
  q: string;
  a: string;
}

export function faqPageSchema(faqs: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

interface BreadcrumbItem {
  name: string;
  path: string;
}

export function breadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function canonical(path: string) {
  return { rel: "canonical" as const, href: `${SITE_URL}${path}` };
}
